// Cast desde celular a la TV: la TV genera/persiste un session-id, lo expone
// vía QR, polea el KV mailbox. El celular abre /cast/:session y POSTea videos.

const SESSION_KEY = 'wiphub_cast_session'

export function getOrCreateCastSession(): string {
  let s: string | null = null
  try {
    s = localStorage.getItem(SESSION_KEY)
  } catch {
    // ignore
  }
  if (s && /^[A-Za-z0-9_-]{8,64}$/.test(s)) return s
  const fresh = crypto.randomUUID().replaceAll('-', '')
  try {
    localStorage.setItem(SESSION_KEY, fresh)
  } catch {
    // ignore
  }
  return fresh
}

export interface PollResult {
  video_id: string | null
}

// GET /api/cast/:session — devuelve { video_id } y borra del KV, o 204 si vacío.
export async function pollCast(session: string): Promise<PollResult> {
  const res = await fetch(`/api/cast/${session}`, { method: 'GET', cache: 'no-store' })
  if (res.status === 204) return { video_id: null }
  if (!res.ok) throw new Error(`poll failed: ${res.status}`)
  const data = (await res.json()) as { video_id?: string }
  return { video_id: typeof data.video_id === 'string' ? data.video_id : null }
}

// POST /api/cast/:session — celular envía un video.
export async function sendCast(session: string, video_url: string): Promise<{ video_id: string }> {
  const res = await fetch(`/api/cast/${session}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ video_url }),
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(text || `send failed: ${res.status}`)
  }
  return res.json()
}
